import ControlTower from '@/modules-v2/control-tower/views/index';

const order = [
  {
    path: '/control-tower',
    name: 'ControlTower',
    component: ControlTower,
    meta: {
      title: 'ControlTower',
      requiresAuth: true,
    },
  },
];

export default order;
